
import { supabase } from '../lib/supabase';
import { Building, ResidentUnit, Announcement, MaintenanceTicket, Vote, CalendarEvent, MonthlyPayment } from '../types';
import * as MOCK from '../mockData';

export interface Expense {
  id: string;
  description: string;
  amount: number;
  date: string;
  category: string;
}

const USE_MOCK = true; // Секогаш користи Mock за демонстрација доколку нема активна база

export const supabaseService = {
  // Финансии - Уплати
  async getPayments(month: number, year: number) {
    if (USE_MOCK) return [];
    try {
      const { data, error } = await supabase
        .from('payments')
        .select('*')
        .eq('month', month)
        .eq('year', year);
      
      if (error) throw error;
      return data as MonthlyPayment[];
    } catch (e) {
      console.warn("Supabase Payments Error, falling back to mock", e);
      return [];
    }
  },

  async upsertPayment(payment: MonthlyPayment) {
    if (USE_MOCK) return;
    const { error } = await supabase
      .from('payments')
      .upsert(payment, { onConflict: 'unitId,month,year' });
    if (error) throw new Error(error.message);
  },

  // Финансии - Трошоци
  async getExpenses() {
    if (USE_MOCK) return [
      { id: 'ex-1', description: 'Поправка на влезни врати', amount: 4500, date: '2024-05-15', category: 'ОДРЖУВАЊЕ' },
      { id: 'ex-2', description: 'Чистење заеднички простории', amount: 2000, date: '2024-05-10', category: 'ХИГИЕНА' }
    ];
    try {
      const { data, error } = await supabase
        .from('expenses')
        .select('*')
        .order('date', { ascending: false });
      
      if (error) throw error;
      return data as Expense[];
    } catch (e) {
      console.warn("Supabase Expenses Error", e);
      return [];
    }
  },

  // Станари
  async getResidents() {
    if (USE_MOCK) return MOCK.MOCK_RESIDENTS;
    try {
      const { data, error } = await supabase
        .from('residents')
        .select('*')
        .order('unitNumber');
      
      if (error) throw error;
      return data as ResidentUnit[];
    } catch (e) {
      return MOCK.MOCK_RESIDENTS;
    }
  },

  async saveResident(resident: Partial<ResidentUnit>) {
    if (USE_MOCK) return resident as ResidentUnit;
    const { data, error } = await supabase.from('residents').upsert(resident).select().single();
    if (error) throw new Error(error.message);
    return data as ResidentUnit;
  },

  // Известувања
  async getAnnouncements() {
    if (USE_MOCK) return MOCK.MOCK_ANNOUNCEMENTS;
    try {
      const { data, error } = await supabase
        .from('announcements')
        .select('*')
        .order('date', { ascending: false });
      
      if (error) throw error;
      return data as Announcement[];
    } catch (e) {
      return MOCK.MOCK_ANNOUNCEMENTS;
    }
  },

  // Дефекти
  async getTickets() {
    if (USE_MOCK) return MOCK.MOCK_TICKETS;
    try {
      const { data, error } = await supabase
        .from('tickets')
        .select('*')
        .order('createdAt', { ascending: false });
      
      if (error) throw error;
      return data as MaintenanceTicket[];
    } catch (e) {
      return MOCK.MOCK_TICKETS;
    }
  }
};
